/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliParentInvitationListItemDto } from '../../models/amoxcalli-parent-invitation-list-item-dto';

export interface ApiParentInvitationsByStudentStudentIdGet$Json$Params {
  studentId: string;
  institutionId?: string;
}

export function apiParentInvitationsByStudentStudentIdGet$Json(http: HttpClient, rootUrl: string, params: ApiParentInvitationsByStudentStudentIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AmoxcalliParentInvitationListItemDto>>> {
  const rb = new RequestBuilder(rootUrl, apiParentInvitationsByStudentStudentIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('studentId', params.studentId, {});
    rb.query('institutionId', params.institutionId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AmoxcalliParentInvitationListItemDto>>;
    })
  );
}

apiParentInvitationsByStudentStudentIdGet$Json.PATH = '/api/parent-invitations/by-student/{studentId}';
